import React, {Component} from 'react';

class IconHamburger extends Component {
    render() {
        const {color} = this.props;
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="15" viewBox="0 0 24 15">
                <g fill="none" fillRule="evenodd" stroke={color || "#23f120"} strokeLinecap="square" strokeWidth="2">
                    <path d="M1.611 1.25H22.39M1.611 7.25H22.39M1.611 13.25H22.39"/>
                </g>
            </svg>
        );
    }
}

export default IconHamburger